import {
  EnterpriseUserBody,
  PatchEnterpriseUserBody,
} from "@app/common/account/api";
import { httpDelete, patch, post, uploadFile } from "@app/common/api";
import { EnterpriseTeamSettings } from "@app/common/workspaces/types";

export const createTeam = async (workspaceId: string, name: string) => {
  return post(
    `/enterprise/workspaces/${workspaceId}/teams`,
    { name },
    { withCreds: true }
  );
};

export const updateTeamName = async (
  workspaceId: string,
  teamId: string,
  name: string
) => {
  return patch(
    `/enterprise/workspaces/${workspaceId}/teams/${teamId}`,
    { name },
    { withCreds: true }
  );
};

export const updateTeamSettings = async (
  workspaceId: string,
  teamId: string,
  settings: Partial<EnterpriseTeamSettings>
) => {
  return patch(
    `/enterprise/workspaces/${workspaceId}/teams/${teamId}`,
    { settings },
    { withCreds: true }
  );
};

export const deleteTeam = async (
  workspaceId: string,
  teamId: string
): Promise<void> => {
  return await httpDelete(
    `/enterprise/workspaces/${workspaceId}/teams/${teamId}`,
    { withCreds: true }
  );
};

export const createTeamUser = async (
  workspaceId: string,
  teamId: string,
  user: EnterpriseUserBody
) => {
  return await post(
    `/enterprise/workspaces/${workspaceId}/teams/${teamId}/users`,
    user,
    { withCreds: true }
  );
};

export const patchTeamUser = async (
  workspaceId: string,
  teamId: string,
  user: PatchEnterpriseUserBody
) => {
  const { userId, role } = user;
  return await patch(
    `/enterprise/workspaces/${workspaceId}/teams/${teamId}/users/${userId}`,
    { role },
    { withCreds: true }
  );
};

export const deleteTeamUser = async (
  workspaceId: string,
  teamId: string,
  userId: string
) => {
  return await httpDelete(
    `/enterprise/workspaces/${workspaceId}/teams/${teamId}/users/${userId}`,
    { withCreds: true }
  );
};

export const uploadCustomLogo = async (workspaceId: string, file: File) => {
  return await uploadFile(
    `/enterprise/workspaces/${workspaceId}/custom-bot-logo`,
    file,
    { withCreds: true }
  );
};

export const deleteCustomLogo = async (workspaceId: string) => {
  return await httpDelete(
    `/enterprise/workspaces/${workspaceId}/custom-bot-logo`,
    { withCreds: true }
  );
};
